import { TranslationMap } from '@trimble-gcs/i18n-types';

export function singleSelectedTranslations() {
  return {
    title: {
      text: $localize`:@@singleSelected.title:Details`,
      desc: 'Title for the details panel that shows information about a selected scan.',
    },
    close: {
      tooltip: {
        text: $localize`:@@singleSelected.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the details panel and unselects the scan.',
      },
    },
    preview: {
      notAvailable: {
        text: $localize`:@@singleSelected.preview.notAvailable:No preview available`,
        desc: 'Button tooltip when the preview of the selected scan is not available.',
      },
      hide: {
        text: $localize`:@@singleSelected.preview.hide:Hide preview`,
        desc: 'Button tooltip to hide the preview of the selected scan.',
      },
      show: {
        text: $localize`:@@singleSelected.preview.show:Show preview`,
        desc: 'Button tooltip to show the preview of the selected scan.',
      },
    },
    viewIn3d: {
      text: $localize`:@@singleSelected.viewIn3d:View in 3D`,
      desc: 'Button text to open the selected scan in the 3D viewer.',
    },
    viewInNumark: {
      text: $localize`:@@singleSelected.viewInNumark:View in Multi-pane`,
      desc:
        'Button text to open the selected item in Numark. ' +
        "The term 'Multi-pane' is a brand name and not translated.",
    },
    download: {
      tooltip: {
        text: $localize`:@@singleSelected.download.tooltip:Download`,
        desc: "Tooltip for the download button to download the selected scan's files.",
      },
    },
    delete: {
      tooltip: {
        text: $localize`:@@singleSelected.delete.tooltip:Recycle`,
        desc: 'Tooltip for the recycle button that moves the selected scan to the recycle bin.',
      },
    },
    deleteConfirmation: {
      title: {
        text: $localize`:@@singleSelected.deleteConfirmation.title:Delete {Reality Capture} Data`,
        desc:
          'Title for the delete scan confirmation dialog. ' +
          "The term 'Reality Capture' is the product name and is not translated.",
      },
      message: {
        text: $localize`:@@singleSelected.deleteConfirmation.message:Are you sure you want to recycle this data?`,
        desc: 'Message for the recycle scan confirmation dialog.',
      },
      confirm: {
        text: $localize`:@@singleSelected.deleteConfirmation.confirm:Recycle`,
        desc: 'Text for the recycle button in the recycle scan confirmation dialog.',
      },
    },
    tabs: {
      properties: {
        text: $localize`:@@singleSelected.tabProperties:Properties`,
        desc: "Tab title to view the selected scan's properties.",
      },
      tags: {
        text: $localize`:@@singleSelected.tabTags:Tagging`,
        desc: "Tab title to view the selected scan's tags.",
      },
      classifications: {
        text: $localize`:@@singleSelected.tabClassifications:Classification`,
        desc: "Tab title to view the selected scan's classifications.",
      },
    },
  } satisfies TranslationMap;
}
